"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_circle_cross_fill_style_1 = __importDefault(require("./uicon.circle.cross.fill.style"));
class UiconCircleCrossFill extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.276 29.552C13.6503 29.552 11.0835 28.7734 8.90026 27.3146C6.71703 25.8558 5.01541 23.7824 4.01058 21.3565C3.00575 18.9306 2.74284 16.2613 3.2551 13.686C3.76736 11.1107 5.03178 8.74514 6.88846 6.88846C8.74515 5.03177 11.1107 3.76736 13.686 3.2551C16.2613 2.74284 18.9306 3.00575 21.3565 4.01058C23.7824 5.01541 25.8558 6.71703 27.3146 8.90026C28.7734 11.0835 29.552 13.6503 29.552 16.276C29.5483 19.7959 28.1484 23.1705 25.6595 25.6595C23.1705 28.1484 19.7959 29.5483 16.276 29.552ZM12.5352 11.6157L11.616 12.535L15.3569 16.2759L11.616 20.0169L12.5352 20.9361L16.2762 17.1952L20.0171 20.9361L20.9363 20.0169L17.1954 16.2759L20.9363 12.535L20.0171 11.6158L16.2762 15.3567L12.5352 11.6157Z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconCircleCrossFill.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconCircleCrossFill.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_circle_cross_fill_style_1.default)(UiconCircleCrossFill);
//# sourceMappingURL=uicon.circle.cross.fill.js.map